import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UrlServidor } from '../util/url-servidor';
import { Observable } from 'rxjs';
import { PageResponse } from '../api/dto/paginacao/page-response';
import { AgendaEmpresaResponse } from '../api/dto/agenda-empresa-response';
import { AgendaEmpresaRequest } from '../api/dto/agenda-empresa-request';
import { HttpParamsUtil } from '../util/http-params-util';
import { DateUtil } from '../util/date-util';
import { AgendaClienteDetalhe } from '../api/dto/agenda-cliente-detalhe';
import { AgendaEmpresaLoteRequest } from '../api/dto/agenda-empresa-lote-request';

@Injectable({
    providedIn: 'root'
})
export class AgendaEmpresaService {

    constructor(private http: HttpClient) { }

    private url: string = UrlServidor.URL_BASE + 'agenda-empresa';

    buscarPorId(agendaEmpresaId: number): Observable<AgendaEmpresaResponse> {
        return this.http.get<AgendaEmpresaResponse>(this.url + "/" + agendaEmpresaId);
    }

    listarPorProfissional(profissionalId: number, dataFiltro?: Date,
        status?: string, pagina?: number, tamanho?: number): Observable<PageResponse<AgendaEmpresaResponse>> {
        let parametros = new HttpParams();
        if (dataFiltro) {
            parametros = parametros.set('dataFiltro', dataFiltro.toISOString());
        }
        if (status) {
            parametros = parametros.set('status', status);
        }

        if (pagina) {
            parametros = parametros.set('page', pagina)
        }
        if (tamanho) {
            parametros = parametros.set('size', tamanho)
        }
        return this.http.get<PageResponse<AgendaEmpresaResponse>>(`${this.url}/profissional/${profissionalId}`, { params: parametros });
    }

    salvarAgendamento(agendaEmpresa: AgendaEmpresaRequest): Observable<AgendaEmpresaResponse> {
        return this.http.post<AgendaEmpresaResponse>(this.url, agendaEmpresa);
    }

    salvarAgendamentoLote(agendaEmpresaLote: AgendaEmpresaLoteRequest) {
        return this.http.post<AgendaEmpresaLoteRequest>(this.url + "/lote", agendaEmpresaLote);
    }

    excluir(agendaEmpresaId?: number): Observable<void> {
        return this.http.delete<void>(`${this.url}/${agendaEmpresaId}`);
    }

    confirmar(agendaEmpresaId?: number): Observable<void> {
        return this.http.put<void>(`${this.url}/${agendaEmpresaId}/confirmacao`, {});
    }

    atualizarDescricao(agendaEmpresaId: number, novaDescricao: string): Observable<void> {
        const descricaoRequest = { descricao: novaDescricao };
        return this.http.patch<void>(`${this.url}/${agendaEmpresaId}/descricao`, descricaoRequest)
    }

    criarComandaAgendamento(clienteId?: number, data?: Date): Observable<void> {
        return this.http.post<void>(`${this.url}/criar-comanda/cliente/${clienteId}/data/${data}`, {});
    }

    adicionarItem(agendaEmpresaId?: number, itemAgendamentoId?: number): Observable<void> {
        return this.http.post<void>(`${this.url}/${agendaEmpresaId}/item-agendamento/${itemAgendamentoId}`, {});
    }

    reagendar(agendaEmpresaId: number, reagendarDto: any): Observable<void> {
        return this.http.patch<void>(`${this.url}/${agendaEmpresaId}/reagendar`, reagendarDto);
    }

    alterarPreferencia(agendaEmpresaId: number, preferencial: boolean): Observable<void> {
        return this.http.put<void>(`${this.url}/${agendaEmpresaId}/alteracao-preferencia`, preferencial);
    }

    cancelar(agendaEmpresaId: number): Observable<void> {
        return this.http.put<void>(`${this.url}/${agendaEmpresaId}/cancelamento`, {});
    }

    reativar(agendaEmpresaId: number): Observable<void> {
        return this.http.put<void>(`${this.url}/${agendaEmpresaId}/reativacao`, {});
    }


    excluirItemAgendamento(agendaEmpresaId?: number, itemAgendamentoId?: number): Observable<void> {
        return this.http.delete<void>(`${this.url}/${agendaEmpresaId}/item-agendamento/${itemAgendamentoId}`);
    }


    listarAgendamentosDoCliente(
        clienteId: number,
        dataInicio?: Date,
        dataFim?: Date
    ): Observable<AgendaClienteDetalhe[]> {

        const params = HttpParamsUtil.buildHttpParams({
            dataInicio: DateUtil.formatarDataIsoLocal(dataInicio),
            dataFim: DateUtil.formatarDataIsoLocal(dataFim)
        });

        return this.http.get<AgendaClienteDetalhe[]>(
            `${this.url}/clientes/${clienteId}`,
            { params }
        );
    }
}